/// <reference path="../_all.ts" />

module editor {
  'use strict';

  export class ContentTag{
    _lowerdisplayname: string;
    _displayname: string;
    constructor(
      public Id: number,
      public Name: string,
      public Names: { [language: string] : string } 
    ) { }
  }
}